import script from "./RegularizarVendaCanceladaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RegularizarVendaCanceladaModal.vue?vue&type=script&setup=true&lang=js"

import "./RegularizarVendaCanceladaModal.vue?vue&type=style&index=0&id=26022384&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26022384"]])

export default __exports__